import CtaTout from './CtaTout'

export default CtaTout